import { render, staticRenderFns } from "./hotelAllContent.vue?vue&type=template&id=201a32fe&scoped=true"
import script from "./hotelAllContent.vue?vue&type=script&lang=js"
export * from "./hotelAllContent.vue?vue&type=script&lang=js"
import style0 from "./hotelAllContent.vue?vue&type=style&index=0&id=201a32fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a32fe",
  null
  
)

export default component.exports